import { ProfileReadModel, ProfilesClient } from "@app/api2/api";
import { BPColumn } from "@common/BPReactTable";
import { Checkbox } from "@/components/bp/bp-ui";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { convertCasesToLinks, getEmptyFilter, getLabFilter, toDateTime } from "@common/Utils";
import { useUser } from "../Contexts/UserContext";
import { BPDataTable3 } from "../Common/DataTable/BPDataTable3";

export const ProfilesAll = () => {
    const client = new ProfilesClient();
    const user = useUser();


    const columns: BPColumn<ProfileReadModel>[] = [
        getEmptyFilter('referenceVisible', 'References', (filter) => (
            <div style={{ display: 'flex', gap: '1em' }}>
                <Checkbox
                    label="Reference"
                    checked={filter.column.filterValue}
                    onChange={(ev, data) => filter.setFilter(filter.column.id, data.checked)}
                />
            </div>
        )),
        getEmptyFilter('evidenceVisible', 'Evidence', (filter) => (
            <div style={{ display: 'flex', gap: '1em' }}>
                <Checkbox
                    label="Evidence"
                    checked={filter.column.filterValue}
                    onChange={(ev, data) => filter.setFilter(filter.column.id, data.checked)}
                />
            </div>
        )),
        getLabFilter({ name: 'labId', label: window.translation.common.labs, hideIf: user?.user?.hasSingleLab }),
        {
            Cell: (cell) => <>{cell.value ? 'Evid.' : 'Ref.'}</>,
            Header: '',
            accessor: "isEvidence",
            collapsing: false,
            width: '5%',
            disableSortBy: true,
        },
        {
            // Cell: (cell) => `${cell.value}/${cell.row.original.caseName}`,
            Header: window.translation.common.lab,
            accessor: "labName",
            width: '10%',
            cellTitle: true,
        },
        // {
        //     Header: window.translation.common.case,
        //     accessor: 'caseName',
        //     width: '15%',
        //     defaultFilterValue: 'anytime',
        //     Filter: f => <Dropdown selection value={f.column.filterValue} options={[
        //         { id: 'anytime', text: 'Anytime', value: 'anytime' },
        //         { id: 'today', text: 'Today', value: 'today' },
        //         { id: 'thisWeek', text: 'This Week', value: 1 },
        //         { id: 'thisMonth', text: 'This Month', value: 2 },
        //     ]}
        //         onChange={(ev, { value }) => {
        //             f.setFilter(f.column.id, value);
        //         }}></Dropdown>
        // },
        {
            Header: window.translation.common.case,
            disableSortBy: true,
            accessor: 'cases',
            Cell: cell => convertCasesToLinks(cell.value, cell.row.original.labId),
            width: '15%',
        },
        {
            Cell: cell => {
                return cell.row.original.isEvidence ?
                    <a href={buildUrl(AppRoutes.EvidenceDetails, { caseId: (cell.row.original.cases?.length > 0 ? cell.row.original.cases[0].id : null) ?? 0, labId: cell.row.original.labId, evidenceId: cell.row.original.id })}>{cell.value}</a> :
                    <a href={buildUrl(AppRoutes.SampleDetails, { caseId: (cell.row.original.cases?.length > 0 ? cell.row.original.cases[0].id : null) ?? 0, labId: cell.row.original.labId, sampleId: cell.row.original.id })}>{cell.value}</a>;
            },
            Header: window.translation.common.name,
            accessor: 'name',
            // width: '20%'
        },

        {
            Cell: cell => <>{toDateTime(cell.value)}</>,
            Header: window.translation.common.created,
            accessor: 'createdAt',
            cellTitle: (cell) => toDateTime(cell.value),


            // collapsing: true,
            width: '15%',
            // tableCellProps: { textAlign: 'center' }
        },
    ];

    return (
        <BPDataTable3
            singleLine fixed
            storeKey="ProfilesAll"
            
            defaultSortField="createdAt"
            defaultSortAsc={false}
            enableSearch={true}
            dataSource={async (p) => {
                // let withoutCase = p.filters.filter(x => x.id == 'showInactive').map(x => x.value).some(x => true)
                let labId = p.filters.find(x => x.id == 'labId')?.value ?? null
                if (labId == -1)
                    labId = null;

                let referenceVisible = p.filters.find(x => x.id == 'referenceVisible')?.value ?? false;
                let evidenceVisible = p.filters.find(x => x.id == 'evidenceVisible')?.value ?? false;


                let interval = p.filters.find(x => x.id == 'caseName')?.value ?? null
                let from = interval == 'today' ? new Date() : null;
                let to = interval == 'today' ? new Date() : null;

                // console.log(p.filters)

                let pageData = await client.getAllProfiles(p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue, labId, from, to, !evidenceVisible, !referenceVisible);
                return pageData;
            }}
            columns={columns}
        />
    );
};